var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGloologo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.745 224H446.132V699.383H510.745V224Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M737.722 648.32C676.95 648.32 633.292 600.023 633.292 539.996C633.292 481.695 676.601 433.742 737.722 433.742C797.446 433.742 840.056 482.04 840.056 539.996C840.056 600.023 797.446 648.32 737.722 648.32ZM737.722 374.751C640.976 374.751 568.329 448.921 568.329 539.996C568.329 632.451 640.626 707.312 737.722 707.312C833.071 707.312 905.019 632.451 905.019 539.996C905.019 448.921 833.42 374.751 737.722 374.751Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.74 648.32C1056.97 648.32 1013.31 600.023 1013.31 539.996C1013.31 481.695 1056.62 433.742 1117.74 433.742C1177.46 433.742 1220.07 482.04 1220.07 539.996C1220.07 600.023 1177.46 648.32 1117.74 648.32ZM1117.74 374.751C1020.99 374.751 948.345 448.921 948.345 539.996C948.345 632.451 1020.64 707.312 1117.74 707.312C1213.09 707.312 1285.04 632.451 1285.04 539.996C1285.04 448.921 1213.44 374.751 1117.74 374.751Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8066 540.017C44.8066 632.472 117.453 707.333 214.2 707.333C253.666 707.333 288.593 694.568 316.534 673.18V696.293C316.534 770.464 279.861 796.683 212.802 796.683L213.501 856.364C296.626 856.364 380.798 828.076 380.798 681.804V377.531H319.677L316.883 408.58C288.942 387.536 253.666 374.772 214.549 374.772C117.453 374.772 44.8066 448.942 44.8066 540.017ZM214.2 648.341C153.078 648.341 109.77 600.044 109.77 540.017C109.77 481.716 153.078 433.763 214.2 433.763C273.924 433.763 316.534 482.06 316.534 540.017C316.534 600.389 273.924 648.341 214.2 648.341Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1846.48 297.019C1829.61 297.019 1817.46 284.873 1817.46 268.004C1817.46 251.134 1829.61 238.989 1846.48 238.989C1863.35 238.989 1875.49 251.134 1875.49 268.004C1875.49 284.873 1863.35 297.019 1846.48 297.019ZM1868.75 702.555H1824.89V382.04H1868.75V702.555Z",
    fill: "url(#paint0_linear_70_3484)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1567.39 711.329C1481.02 711.329 1410.84 639.129 1410.84 543.312C1410.84 447.494 1482.37 375.969 1567.39 375.969C1636.89 375.969 1673.33 415.105 1690.87 442.096L1696.27 438.722C1692.22 433.324 1690.87 427.926 1690.87 421.178V382.042H1734.73V702.557H1690.87V666.12C1690.87 658.022 1692.89 652.624 1696.27 647.901L1690.87 644.527C1674 670.843 1636.89 711.329 1567.39 711.329ZM1573.46 670.843C1644.99 670.843 1693.57 614.162 1693.57 543.312C1693.57 473.81 1644.99 416.455 1573.46 416.455C1504.63 416.455 1454.03 473.81 1454.03 543.312C1454.03 614.837 1504.63 670.843 1573.46 670.843Z",
    fill: "url(#paint1_linear_70_3484)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_70_3484",
    x1: 1819.37,
    y1: 238.989,
    x2: 1936.51,
    y2: 255.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFDE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFD727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CF8A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90640A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_70_3484",
    x1: 1421.45,
    y1: 375.969,
    x2: 1728.73,
    y2: 708.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFDE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFD727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F6C414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CF8A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90640A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGloologo);
export default __webpack_public_path__ + "static/media/gloologo.1f62e6b814605d0e592cf465a1a73942.svg";
export { ForwardRef as ReactComponent };